module.exports = __webpack_public_path__ + "img/entertainment-3.9949ef5e.jpg";